import { render, staticRenderFns } from "./FormFieldsTextAndSwitch.vue?vue&type=template&id=4f30c949&"
import script from "./FormFieldsTextAndSwitch.vue?vue&type=script&lang=js&"
export * from "./FormFieldsTextAndSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports